/**
 * Shared Quick Setup helpers for the optional Live Demos registration step.
 */

export function getWorkspaceOption(context) {
  if (context.workspaceOption) {
    return context.workspaceOption;
  }
  if (context.workspaceId && context.workspaceId !== -1) {
    return 'existing';
  }
  return 'new';
}

export function hasLinkedLivedemosWorkspace(context) {
  return (
    getWorkspaceOption(context) === 'existing' &&
    !!context.existingLivedemosWorkspaceId
  );
}

/** Whether to show the "Register in Live Demos" opt-in checkbox in the dialog. */
export function showLivedemosOptIn(context) {
  const workspaceOption = getWorkspaceOption(context);
  if (workspaceOption === 'none' || !context.preset?.name) {
    return false;
  }
  if (hasLinkedLivedemosWorkspace(context)) {
    return false;
  }
  // For "Use existing": only show after a workspace with no livedemos link has been chosen.
  if (workspaceOption === 'existing') {
    return !!context.workspaceId && context.workspaceId !== -1;
  }
  // For "Create new": always show.
  return true;
}

/**
 * Whether the post-job Live Demos step runs (create workspace and/or register demo).
 * Reusing a DSN workspace that already has a livedemos link always registers the demo.
 */
export function isLivedemosStepEnabled(context) {
  const workspaceOption = getWorkspaceOption(context);
  if (workspaceOption === 'none' || !context.preset?.name) {
    return false;
  }
  if (hasLinkedLivedemosWorkspace(context)) {
    return true;
  }
  return context.registerInLivedemos !== false;
}
